import { ResetPasswordForm } from '@wa/shared';

/** Where the emailed link lands. Signed out, always — that is the whole point. */
export function ResetPasswordPage() {
  const leave = () => { window.location.replace('/'); };

  return <ResetPasswordForm onDone={leave} onRestart={leave} />;
}
